// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"362":"c04d8bc0","381":"b10f2f7d"}[chunkId] + ".js";
};